import React from "react"
import { MARKS, BLOCKS, INLINES } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

const options = (isWhiteText) => ({
  renderMark: {
    [MARKS.BOLD]: (text) => <b>{text}</b>,
    [MARKS.ITALIC]: (text) => <i>{text}</i>,
    [MARKS.UNDERLINE]: (text) => <u>{text}</u>,
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <p style={{ color: isWhiteText ? "white" : "inherit" }}>{children}</p>
    ),
    [INLINES.HYPERLINK]: ({ data }, children) => (
      <a href={data.uri} style={{ color: isWhiteText ? "white" : "inherit" }}>
        {children}
      </a>
    ),
  },
})

const RichTextContentful = ({ rawRichText, isWhiteText = false }) =>
  documentToReactComponents(JSON.parse(rawRichText), options(isWhiteText))

export default RichTextContentful
